<template>
    <v-navigation-drawer 
        dark 
        app 
        v-model="mainMenu" 
        temporary
        style="width: 265px !important; z-index:900;"
        nw-data="application menu">
        <v-list style="height: 64px;">
            <v-list-item>
                <v-list-item-content>
                <v-list-item-title>
                    <!-- Vivomap -->
                </v-list-item-title>
                <v-list-item-subtitle>
                    <!-- [0.0.1] -->
                </v-list-item-subtitle>
                </v-list-item-content>
                <v-icon style="z-index: 900;position: absolute; top: 11px; right: 15px; color:white;font-size:18pt;" 
                    @click="$emit('close');" 
                    nw-data="program_details close">fa-times</v-icon>
            </v-list-item>
            </v-list>
            <v-divider></v-divider>

            <v-list
                dense
                nav
                >

            <v-list-item style="margin-bottom: 3%;margin-top: 3%;"
                v-for="item in menuItems"
                :key="item.title"
                link
                @click="item.click(item.param)"
                >

                <v-list-item-icon style="width:0">
                    <v-icon  style="font-size:20px;padding-left: 15px;">{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content style="padding-left:15%;;text-align: left;">
                    <v-list-item-title  style="font-size:15px;"><str :index="item.title"/></v-list-item-title>
                </v-list-item-content>

            </v-list-item>
        </v-list>

        <template v-if="user.type=='admin' || user.type == 'tester'">
            <div :class="$style.modeToggle" >
                <v-select 
                    v-model="mode"
                    :items="mode_list"
                    solo 
                    dense
                    label="Mode">

                </v-select>
            </div>
        </template>

    </v-navigation-drawer>  
</template>

<script>
import { mapGetters } from 'vuex';
import _isEmpty from 'lodash/isEmpty';
export default {
    name: 'MainMenu',
    created: function(){
        this.mode = this.storeMode;
        this.mainMenu = this.menu;
    },
    props: {
        menu: {
            type: Boolean,
            required: true
        }
    },
    data: function(){
        return {
            mode: null,
            mainMenu: false
           
        }
    },
    methods: {
        goHome: function(){
            this.$router.push({ path: '/' })
            this.$emit('close')
        },
        goAbout: function(){
            this.$router.push({path: '/about'})
            this.$emit('close')
        },
        goContactUs: function() {
            this.$controller.view.contactUs.open();
            this.$emit('close');
        },
        goFAQ: function(){
            this.$router.push({path: '/faq'})
            this.$emit('close')
        },
        goeditProfile: function() {
            this.$controller.view.editProfile.open();
            this.$emit('close');
        },
        goAdmin: function(){
            this.$router.push({path: '/admin'})
            this.$emit('close')
        },
        goDataDump: function() {
            this.$router.push({path: '/dataDump'});
            this.$emit('close');
        },
        goSiteRegulation: function(siteRegulationTargetTab) {
            this.$controller.view.SiteRegulation.open(siteRegulationTargetTab);            
            this.$emit('close');
        },
        logout: function(){
            this.$controller.security.user.logout();
            this.$emit('close')
        },
        validateResourceAuthorization: function(resource) {
            let user = this.user
            if(!user) {
                return false
            }

            let resourceAuthorization = user.resources_authorization
            let isNullOrEmpty = resourceAuthorization == null || _isEmpty(resourceAuthorization)
            if (isNullOrEmpty) {
                return false
            }

            let hasDataProperty = resourceAuthorization[resource] && resourceAuthorization[resource].length > 0
            if (!hasDataProperty) {
                return false
            }

            return true
        }
    },    
    computed: {
        ...mapGetters({
            'user': 'user',
            'storeMode': 'mode'
        }),
        menuItems: function(){
            var items = [];
           
            items.push({ title: 'menu > home', icon: 'fas fa-home', click:this.goHome})
            items.push({ title: 'menu > about_vivomap', icon: 'fa-id-card', click:this.goAbout })
            items.push({ title: 'menu > contact_us', icon: 'fas fa-headphones', click:this.goContactUs})
            items.push({ title: 'menu > faq', icon: 'fa-question-circle', click:this.goFAQ })
            if(this.user){
                items.push({ title: 'menu > edit_profile', icon: 'fas fa-user-edit', click:this.goeditProfile })              
            }
            let isUserAdmin = this.user.type === 'admin'
            if(isUserAdmin){
                items.push({
                    title: 'menu > admin',
                    icon: 'fas fa-users-cog',
                    click: this.goAdmin
                });
            }
            
            let hasDataResourceAuthorization = this.validateResourceAuthorization('data')
            if(hasDataResourceAuthorization) {
                items.push({
                    title: "menu > dataDump",
                    icon: 'fas fa-download',
                    click: this.goDataDump
                });
            }

            if(this.user){
                items.push({ title: 'site_regulation > terms_of_use', icon: 'fas fa-file-contract', click:this.goSiteRegulation, param:'terms_of_use' })              
            }
            if(this.user){
                items.push({ title: 'button > sign_out', icon: 'fas fa-sign-out-alt', click:this.logout })              
            }

            return items;
        },
        mode_list: function() {
            let mode_list =  [
                {text: 'User Mode', value: 'user'},
                {text: 'Tester Mode', value: 'test'}
            ];
            if(this.user.type === 'admin') {
                mode_list.push({
                    text: 'Editor Mode', value: 'edit'
                });
            }
            return mode_list
        }
    },
    watch:{
        mode: function(){
            this.$store.dispatch('mode',this.mode);
        },
        menu: function(after) {
            this.mainMenu = after;
        },
        mainMenu: function(after, before) {
            if(!after && after != before) {
                this.$emit("close");
            }
        }
    }
}
</script>

<style module>
.modeToggle {
    padding: 0 10px;
}

.modeTogglePrependP {
    color: #c3c3c3; 
    margin-top: 5px; 
    cursor:pointer;
}

</style>